// Hide empty paragraph and h3 elements in product descriptions

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.page__content p span, .page__content h3, .page__content p').forEach(el => {
    const html = el.innerHTML.trim();
    const text = el.textContent.trim();

    // hide if truly empty or only contains &nbsp; / non-breaking space
    if (html === '' || html === '&nbsp;' || text === '\u00A0') {
      el.style.display = 'none';
    }
  });
});

// Collection filter accordions: enforce single-open behavior.
// Uses capture phase because the native `toggle` event does not bubble,
//  and survives the innerHTML re-renders that FacetForm performs.
(function () {
  const FILTER_CONTAINERS = '#FacetFiltersContainer, #MobileFacetFiltersContainer, #DrawerFacetFiltersContainer';

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    if (!details.open) return;
    if (!details.matches('[data-filter]')) return;

    const container = details.closest(FILTER_CONTAINERS);
    if (!container) return;

    container.querySelectorAll('details[data-filter][open]').forEach((other) => {
      if (other !== details) other.open = false;
    });
  }, true);
})();


	var Tawk_API = Tawk_API || {};

	Tawk_API.customStyle = {
		visibility : {
			desktop : {
				position : 'br',
				xOffset : '40px',
				yOffset : '140px',
			},
			mobile : {
				position : 'br',
				xOffset : 0,
				yOffset : '110px'
			},
			bubble : {
				rotate : '0deg',
			 	xOffset : -20,
			 	yOffset : 0
			}
		}
	};